export function dateStringsToDateObject(dateString: string, timeString?: string): Date {
    
    const [year, month, day] = dateString.split('-').map(Number)
    let [hours, minutes] = ['12', '0']
    if (!!timeString) {
        [hours, minutes] = timeString?.split(':')
    }

    const date = new Date(year, month - 1, day)
    date.setHours(parseInt(hours), parseInt(minutes), 0, 0)

    return date
}